"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[921],{

/***/ 37244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(92338);
// EXTERNAL MODULE: ./node_modules/baseui/esm/accordion/styled-components.js
var styled_components = __webpack_require__(3350);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/accordion/constants.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STATE_CHANGE_TYPE = {
  expand: 'expand'
};
;// CONCATENATED MODULE: ./node_modules/baseui/esm/accordion/accordion.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable cup/no-undef */





var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion() {
    var _this;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({
      expanded: []
    }, _this.props.initialState));

    _defineProperty(_assertThisInitialized(_this), "itemRefs", []);

    return _this;
  }

  _createClass(Accordion, [{
    key: "onPanelChange",
    value: //flowlint-next-line unclear-type:off
    function onPanelChange(key, onChange) {
      var activeKeys = this.state.expanded;
      var accordion = this.props.accordion;

      if (accordion) {
        activeKeys = activeKeys[0] === key ? [] : [key];
      } else {
        activeKeys = _toConsumableArray(activeKeys);
        var index = activeKeys.indexOf(key);
        var wasExpanded = index > -1;

        if (wasExpanded) {
          // remove active state
          activeKeys.splice(index, 1);
        } else {
          activeKeys.push(key);
        }
      }

      var newState = {
        expanded: activeKeys
      };
      this.internalSetState(STATE_CHANGE_TYPE.expand, newState); // Call individual panel's onChange handler

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      if (typeof onChange === 'function') onChange.apply(void 0, args);
    }
  }, {
    key: "internalSetState",
    value: function internalSetState(type, changes) {
      var _this$props = this.props,
          stateReducer = _this$props.stateReducer,
          onChange = _this$props.onChange;
      var newState = stateReducer(type, changes, this.state);
      this.setState(newState);
      typeof onChange === 'function' && onChange(newState);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (this.props.disabled) {
        return;
      }

      var itemRefs = this.itemRefs;
      var HOME = 36;
      var END = 35;
      var ARROW_UP = 38;
      var ARROW_DOWN = 40;

      if (e.keyCode === HOME) {
        e.preventDefault();
        var firstItem = itemRefs[0];
        firstItem.current && firstItem.current.focus();
      }

      if (e.keyCode === END) {
        e.preventDefault();
        var lastItem = itemRefs[itemRefs.length - 1];
        lastItem.current && lastItem.current.focus();
      }

      if (e.keyCode === ARROW_UP) {
        e.preventDefault();
        var activeItemIdx = itemRefs.findIndex(function (item) {
          return item.current === document.activeElement;
        });

        if (activeItemIdx > 0) {
          var prevItem = itemRefs[activeItemIdx - 1];
          prevItem.current && prevItem.current.focus();
        }
      }

      if (e.keyCode === ARROW_DOWN) {
        e.preventDefault();

        var _activeItemIdx = itemRefs.findIndex(function (item) {
          return item.current === document.activeElement;
        });

        if (_activeItemIdx < itemRefs.length - 1) {
          var nextItem = itemRefs[_activeItemIdx + 1];
          nextItem.current && nextItem.current.focus();
        }
      }
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      var expanded = this.state.expanded;
      var _this$props2 = this.props,
          accordion = _this$props2.accordion,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          renderAll = _this$props2.renderAll,
          overrides = _this$props2.overrides; // flowlint-next-line unclear-type:off

      return react.Children.map(children, function (child, index) {
        if (!child) return;
        var itemRef = /*#__PURE__*/react.createRef();

        _this2.itemRefs.push(itemRef); // If there is no key provided use the panel order as a default key


        var key = child.key || String(index);
        var isExpanded = false;

        if (accordion) {
          isExpanded = expanded[0] === key;
        } else {
          isExpanded = expanded.includes(key);
        }

        var props = {
          key: key,
          ref: itemRef,
          expanded: isExpanded || child.props.expanded,
          accordion: accordion,
          renderAll: renderAll,
          overrides: child.props.overrides || overrides,
          disabled: child.props.disabled || disabled,
          onChange: function onChange() {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            return _this2.onPanelChange.apply(_this2, [key, child.props.onChange].concat(args));
          }
        };
        return /*#__PURE__*/react.cloneElement(child, props);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;
      var RootOverride = overrides.Root;

      var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(RootOverride, styled_components/* Root */.fC),
          _getOverrides2 = _slicedToArray(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      return /*#__PURE__*/react.createElement(Root, _extends({
        "data-baseweb": "accordion",
        $disabled: this.props.disabled,
        $isFocusVisible: false,
        onKeyDown: this.handleKeyDown.bind(this)
      }, rootProps), this.getItems());
    }
  }]);

  return Accordion;
}(react.Component);

_defineProperty(Accordion, "defaultProps", {
  accordion: true,
  disabled: false,
  initialState: {
    expanded: []
  },
  onChange: function onChange() {},
  overrides: {},
  renderAll: false,
  stateReducer: function stateReducer(type, newState) {
    return newState;
  }
});



/***/ }),

/***/ 80027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _locale_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78303);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92338);
/* harmony import */ var _styled_components_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3350);
/* harmony import */ var _utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73495);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/






var Panel = function Panel(_ref, ref) {
  var ariaControls = _ref['aria-controls'],
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$renderAll = _ref.renderAll,
      renderAll = _ref$renderAll === void 0 ? false : _ref$renderAll;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    expanded: expanded,
    isFocusVisible: false,
    elementHeight: 0,
    animationInProgress: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localState = _React$useState2[0],
      setLocalState = _React$useState2[1];

  var handleFocus = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (event) {
    if ((0,_utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_1__/* .isFocusVisible */ .E)(event)) {
      setLocalState(_objectSpread(_objectSpread({}, localState), {}, {
        isFocusVisible: true
      }));
    }
  }, [localState]);
  var handleBlur = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (event) {
    if (localState.isFocusVisible) {
      setLocalState(_objectSpread(_objectSpread({}, localState), {}, {
        isFocusVisible: false
      }));
    }
  }, [localState]);
  var handleClick = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (e) {
    if (disabled) {
      return;
    }

    typeof onChange === 'function' && onChange({
      expanded: !expanded
    });
    typeof onClick === 'function' && onClick(e);
  }, [expanded, disabled, onChange, onClick]);
  var handleKeyDown = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (e) {
    if (disabled) {
      return;
    }

    var ENTER = 13;
    var SPACE = 32;

    if (e.keyCode === ENTER || e.keyCode === SPACE) {
      typeof onChange === 'function' && onChange({
        expanded: !expanded
      });

      if (e.keyCode === SPACE) {
        e.preventDefault(); // prevent jumping scroll when using Space
      }
    }

    typeof onKeyDown === 'function' && onKeyDown(e);
  }, [expanded, disabled, onChange, onKeyDown]); // flowlint-next-line unclear-type:off

  var _animateRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (_animateRef.current) {
      var height = _animateRef.current.getBoundingClientRect().height; // After the first render, when everything is in the DOM, update the local
      //state to indicate an animation is in progress.


      if (expanded !== localState.expanded) {
        setLocalState(_objectSpread(_objectSpread({}, localState), {}, {
          expanded: expanded,
          animationInProgress: true
        }));
      } else if (parseInt(localState.elementHeight) !== height) {
        // After the second render (where child elements were added to the Content)
        //the Content height now reflects the true height. This kicks off the actual
        //animation.
        setLocalState(_objectSpread(_objectSpread({}, localState), {}, {
          elementHeight: height ? "".concat(height, "px") : 0
        }));
      }
    }
  }, [_animateRef.current, expanded, localState.elementHeight, localState.expanded, setLocalState]);
  var contentHeight = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    // When closing, the first render will re-query the content element for the new
    //height and set the height of the animation container from auto to a px value.
    if (!expanded && localState.expanded) {
      var height = _animateRef.current.getBoundingClientRect().height;

      setLocalState(_objectSpread(_objectSpread({}, localState), {}, {
        elementHeight: height ? "".concat(height, "px") : 0
      }));
      return localState.elementHeight;
    }

    if (!localState.expanded) {
      return 0;
    } // When no longer animating, set the height to auto to accommodate dynamic nested components.


    return localState.animationInProgress ? localState.elementHeight : 'auto';
  }, [expanded, localState.expanded, localState.animationInProgress, localState.elementHeight]);
  var sharedProps = {
    $disabled: disabled,
    $expanded: expanded,
    $isFocusVisible: localState.isFocusVisible
  };
  var PanelContainerOverride = overrides.PanelContainer,
      HeaderOverride = overrides.Header,
      ContentOverride = overrides.Content,
      ContentAnimationContainerOverride = overrides.ContentAnimationContainer,
      ToggleIconOverride = overrides.ToggleIcon,
      ToggleIconGroupOverride = overrides.ToggleIconGroup;

  var _getOverrides = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(PanelContainerOverride, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .PanelContainer */ .lk),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      PanelContainer = _getOverrides2[0],
      panelContainerProps = _getOverrides2[1];

  var _getOverrides3 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(HeaderOverride, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .Header */ .h4),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      Header = _getOverrides4[0],
      headerProps = _getOverrides4[1];

  var _getOverrides5 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(ContentOverride, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY),
      _getOverrides6 = _slicedToArray(_getOverrides5, 2),
      Content = _getOverrides6[0],
      contentProps = _getOverrides6[1];

  var _getOverrides7 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(ContentAnimationContainerOverride, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .ContentAnimationContainer */ .D7),
      _getOverrides8 = _slicedToArray(_getOverrides7, 2),
      ContentAnimationContainer = _getOverrides8[0],
      contentAnimationProps = _getOverrides8[1];

  var _getOverrides9 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(ToggleIconGroupOverride, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .ToggleIconGroup */ .bx),
      _getOverrides10 = _slicedToArray(_getOverrides9, 2),
      ToggleIconGroup = _getOverrides10[0],
      toggleIconGroupProps = _getOverrides10[1];

  var _getOverrides11 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(ToggleIconOverride, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .ToggleIcon */ .Xs),
      _getOverrides12 = _slicedToArray(_getOverrides11, 2),
      ToggleIcon = _getOverrides12[0],
      toggleIconProps = _getOverrides12[1];

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_locale_index_js__WEBPACK_IMPORTED_MODULE_4__/* .LocaleContext.Consumer */ .R.Consumer, null, function (locale) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(PanelContainer, _extends({}, sharedProps, panelContainerProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Header, _extends({
      tabIndex: 0,
      role: "button",
      "aria-expanded": expanded,
      "aria-disabled": disabled || null
    }, sharedProps, headerProps, ariaControls ? {
      'aria-controls': ariaControls
    } : {}, {
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      onFocus: (0,_utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_1__/* .forkFocus */ .Ah)(headerProps, handleFocus),
      onBlur: (0,_utils_focusVisible_js__WEBPACK_IMPORTED_MODULE_1__/* .forkBlur */ .Z5)(headerProps, handleBlur),
      ref: ref
    }), title, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ToggleIcon, _extends({
      viewBox: "0 0 24 24",
      title: localState.expanded ? locale.accordion.collapse : locale.accordion.expand,
      size: 16
    }, toggleIconProps, sharedProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ToggleIconGroup, _extends({}, sharedProps, toggleIconGroupProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z"
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentAnimationContainer, _extends({}, sharedProps, contentAnimationProps, {
      $height: contentHeight,
      onTransitionEnd: function onTransitionEnd() {
        if (localState.animationInProgress) {
          setLocalState(_objectSpread(_objectSpread({}, localState), {}, {
            animationInProgress: false
          }));
        }
      }
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, _extends({
      ref: _animateRef
    }, sharedProps, contentProps, ariaControls ? {
      id: ariaControls
    } : {}), localState.expanded || renderAll || localState.animationInProgress ? children : null)));
  });
};

var ForwardedPanel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Panel);
ForwardedPanel.displayName = 'Panel';
/* harmony default export */ __webpack_exports__["Z"] = (ForwardedPanel);

/***/ }),

/***/ 3350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D7": function() { return /* binding */ ContentAnimationContainer; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "Xs": function() { return /* binding */ ToggleIcon; },
/* harmony export */   "bx": function() { return /* binding */ ToggleIconGroup; },
/* harmony export */   "fC": function() { return /* binding */ Root; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "lk": function() { return /* binding */ PanelContainer; }
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67265);
/* harmony import */ var _icon_styled_components_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46869);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



/**
 * Main component container element
 */
var Root = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('ul', {
  listStyleType: 'none',
  marginBottom: 0,
  marginTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  width: '100%'
});
Root.displayName = "Root";
var PanelContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('li', function (props) {
  var $expanded = props.$expanded,
      colors = props.$theme.colors;
  return {
    listStyleType: 'none',
    width: '100%',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: $expanded ? colors.mono500 : colors.mono400
  };
});
PanelContainer.displayName = "PanelContainer";
var Header = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (props) {
  var $disabled = props.$disabled,
      $isFocusVisible = props.$isFocusVisible,
      _props$$theme = props.$theme,
      colors = _props$$theme.colors,
      sizing = _props$$theme.sizing,
      typography = _props$$theme.typography;
  return _objectSpread(_objectSpread({}, typography.font350), {}, {
    color: colors.contentPrimary,
    cursor: $disabled ? 'not-allowed' : 'pointer',
    backgroundColor: colors.listHeaderFill,
    paddingTop: sizing.scale600,
    paddingBottom: sizing.scale600,
    paddingLeft: sizing.scale700,
    paddingRight: sizing.scale700,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    display: 'flex',
    alignItems: 'center',
    outline: $isFocusVisible ? "3px solid ".concat(colors.accent) : 'none',
    outlineOffset: '-3px',
    justifyContent: 'space-between',
    ':hover': {
      color: colors.primary
    }
  });
});
Header.displayName = "Header";
var ToggleIcon = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('svg', function (props) {
  var $theme = props.$theme,
      $disabled = props.$disabled,
      $color = props.$color;
  return _objectSpread(_objectSpread({}, (0,_icon_styled_components_js__WEBPACK_IMPORTED_MODULE_1__/* .getSvgStyles */ .u)(props)), {}, {
    flexShrink: 0,
    color: $color || $theme.colors.contentPrimary,
    cursor: $disabled ? 'not-allowed' : 'pointer'
  });
});
ToggleIcon.displayName = "ToggleIcon";
var ToggleIconGroup = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('g', function (props) {
  var $theme = props.$theme,
      $expanded = props.$expanded;
  return {
    transform: $expanded ? 'rotate(0)' : 'rotate(-90deg)',
    transformOrigin: 'center',
    transitionProperty: 'transform',
    transitionDuration: $theme.animation.timing500,
    transitionTimingFunction: $theme.animation.easeOutQuinticCurve
  };
});
ToggleIconGroup.displayName = "ToggleIconGroup";
var Content = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (props) {
  var _props$$theme2 = props.$theme,
      animation = _props$$theme2.animation,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing,
      typography = _props$$theme2.typography,
      $expanded = props.$expanded;
  return _objectSpread(_objectSpread({}, typography.font200), {}, {
    backgroundColor: colors.listBodyFill,
    color: colors.contentPrimary,
    paddingTop: sizing.scale800,
    paddingBottom: sizing.scale1000,
    paddingLeft: sizing.scale800,
    paddingRight: sizing.scale800,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
    opacity: $expanded ? 1 : 0,
    visibility: $expanded ? 'visible' : 'hidden',
    transitionProperty: 'opacity,visibility',
    transitionDuration: animation.timing500,
    transitionDelay: animation.timing200,
    transitionTimingFunction: animation.easeOutQuinticCurve
  });
});
Content.displayName = "Content";
var ContentAnimationContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (props) {
  var $height = props.$height,
      animation = props.$theme.animation;
  return {
    height: "".concat($height),
    overflow: 'hidden',
    transitionProperty: 'height',
    transitionDuration: animation.timing500,
    transitionTimingFunction: animation.easeOutQuinticCurve
  };
});
ContentAnimationContainer.displayName = "ContentAnimationContainer";

/***/ }),

/***/ 69530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cell; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92338);
/* harmony import */ var _styled_components_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31691);
/* harmony import */ var _grid_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54702);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




function Cell(_ref) {
  var align = _ref.align,
      children = _ref.children,
      gridColumns = _ref.gridColumns,
      gridGaps = _ref.gridGaps,
      gridGutters = _ref.gridGutters,
      gridUnit = _ref.gridUnit,
      order = _ref.order,
      skip = _ref.skip,
      span = _ref.span,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _getOverrides = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_1__/* .getOverrides */ .jb)(overrides.Cell, _styled_components_js__WEBPACK_IMPORTED_MODULE_2__/* .StyledCell */ .ji),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      StyledCell = _getOverrides2[0],
      overrideProps = _getOverrides2[1];

  var gridContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_grid_js__WEBPACK_IMPORTED_MODULE_3__/* .GridContext */ ._);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCell, _extends({
    $align: align // TODO(v11): Remove the four grid props, get them solely from GridContext
    ,
    $gridColumns: gridColumns || gridContext.gridColumns,
    $gridGaps: gridGaps || gridContext.gridGaps,
    $gridGutters: gridGutters || gridContext.gridGutters,
    $gridUnit: gridUnit || gridContext.gridUnit,
    $order: order,
    $skip: skip,
    $span: span
  }, overrideProps), children);
}

/***/ }),

/***/ 68358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BI": function() { return /* binding */ STYLE; },
/* harmony export */   "id": function() { return /* binding */ STYLE_VALUES; },
/* harmony export */   "m6": function() { return /* binding */ BEHAVIOR; },
/* harmony export */   "xy": function() { return /* binding */ ALIGNMENT; }
/* harmony export */ });
var _Object$freeze;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var BEHAVIOR = Object.freeze({
  fluid: 'fluid',
  fixed: 'fixed'
});
var ALIGNMENT = Object.freeze({
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
});
var STYLE = Object.freeze({
  default: 'default',
  compact: 'compact'
});
var STYLE_VALUES = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, STYLE.default, null), _defineProperty(_Object$freeze, STYLE.compact, {
  columns: [4, 8, 12],
  gutters: [16, 16, 16],
  margins: [16, 24, 24],
  gaps: 0,
  unit: 'px',
  maxWidth: 1280
}), _Object$freeze));

/***/ }),

/***/ 54702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Grid; },
/* harmony export */   "_": function() { return /* binding */ GridContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92338);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68358);
/* harmony import */ var _styled_components_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31691);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




var GridContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
function Grid(_ref) {
  var align = _ref.align,
      behavior = _ref.behavior,
      children = _ref.children,
      gridColumns = _ref.gridColumns,
      gridGaps = _ref.gridGaps,
      gridGutters = _ref.gridGutters,
      gridMargins = _ref.gridMargins,
      gridMaxWidth = _ref.gridMaxWidth,
      _ref$gridStyle = _ref.gridStyle,
      gridStyle = _ref$gridStyle === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .STYLE["default"] */ .BI["default"] : _ref$gridStyle,
      gridUnit = _ref.gridUnit,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _getOverrides = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(overrides.Grid, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .StyledGrid */ .HF),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      StyledGrid = _getOverrides2[0],
      overrideProps = _getOverrides2[1];

  var _getOverrides3 = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .getOverrides */ .jb)(overrides.GridWrapper, _styled_components_js__WEBPACK_IMPORTED_MODULE_3__/* .StyledGridWrapper */ .Cf),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      StyledGridWrapper = _getOverrides4[0],
      wrapperProps = _getOverrides4[1];

  var presetStyleValues = _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .STYLE_VALUES */ .id[gridStyle];
  var gridStyleValues = presetStyleValues ? {
    $gridGutters: presetStyleValues.gutters,
    $gridMargins: presetStyleValues.margins,
    $gridMaxWidth: presetStyleValues.maxWidth,
    $gridUnit: presetStyleValues.unit
  } : {};
  var gridContextStyleValues = presetStyleValues && {
    gridColumns: presetStyleValues.columns,
    gridGaps: presetStyleValues.gaps,
    gridGutters: presetStyleValues.gutters,
    gridUnit: presetStyleValues.unit
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledGridWrapper, _extends({
    $behavior: behavior,
    $gridMargins: gridMargins != null ? gridMargins : gridStyleValues.$gridMargins,
    $gridMaxWidth: gridMaxWidth != null ? gridMaxWidth : gridStyleValues.$gridMaxWidth,
    $gridUnit: gridUnit != null ? gridUnit : gridStyleValues.$gridUnit
  }, wrapperProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledGrid, _extends({
    $align: align,
    $behavior: behavior,
    $gridGutters: gridGutters != null ? gridGutters : gridStyleValues.$gridGutters,
    $gridMargins: gridMargins != null ? gridMargins : gridStyleValues.$gridMargins,
    $gridMaxWidth: gridMaxWidth != null ? gridMaxWidth : gridStyleValues.$gridMaxWidth,
    $gridUnit: gridUnit != null ? gridUnit : gridStyleValues.$gridUnit
  }, overrideProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(GridContext.Provider, {
    value: _objectSpread({
      gridColumns: gridColumns,
      gridGaps: gridGaps,
      gridGutters: gridGutters,
      gridUnit: gridUnit
    }, gridContextStyleValues)
  }, children)));
}

/***/ }),

/***/ 31691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ StyledGridWrapper; },
/* harmony export */   "HF": function() { return /* binding */ StyledGrid; },
/* harmony export */   "ji": function() { return /* binding */ StyledCell; }
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67265);
/* harmony import */ var _helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41141);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68358);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



var StyledGridWrapper = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref) {
  var $theme = _ref.$theme,
      _ref$$behavior = _ref.$behavior,
      $behavior = _ref$$behavior === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .BEHAVIOR.fixed */ .m6.fixed : _ref$$behavior,
      _ref$$gridMargins = _ref.$gridMargins,
      $gridMargins = _ref$$gridMargins === void 0 ? $theme.grid.margins : _ref$$gridMargins,
      _ref$$gridMaxWidth = _ref.$gridMaxWidth,
      $gridMaxWidth = _ref$$gridMaxWidth === void 0 ? $theme.grid.maxWidth : _ref$$gridMaxWidth,
      _ref$$gridUnit = _ref.$gridUnit,
      $gridUnit = _ref$$gridUnit === void 0 ? $theme.grid.unit : _ref$$gridUnit;
  return {
    margin: 'auto',
    maxWidth: $behavior === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .BEHAVIOR.fixed */ .m6.fixed ? "".concat($gridMaxWidth + 2 * getResponsiveNumber($gridMargins, Infinity) - 1).concat($gridUnit) : null
  };
});
StyledGridWrapper.displayName = "StyledGridWrapper";
var StyledGrid = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref2) {
  var $theme = _ref2.$theme,
      _ref2$$align = _ref2.$align,
      $align = _ref2$$align === void 0 ? null : _ref2$$align,
      _ref2$$behavior = _ref2.$behavior,
      $behavior = _ref2$$behavior === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .BEHAVIOR.fixed */ .m6.fixed : _ref2$$behavior,
      _ref2$$gridGutters = _ref2.$gridGutters,
      $gridGutters = _ref2$$gridGutters === void 0 ? $theme.grid.gutters : _ref2$$gridGutters,
      _ref2$$gridMargins = _ref2.$gridMargins,
      $gridMargins = _ref2$$gridMargins === void 0 ? $theme.grid.margins : _ref2$$gridMargins,
      _ref2$$gridMaxWidth = _ref2.$gridMaxWidth,
      $gridMaxWidth = _ref2$$gridMaxWidth === void 0 ? $theme.grid.maxWidth : _ref2$$gridMaxWidth,
      _ref2$$gridUnit = _ref2.$gridUnit,
      $gridUnit = _ref2$$gridUnit === void 0 ? $theme.grid.unit : _ref2$$gridUnit;
  var mediaQueries = (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .getMediaQueries */ .W)($theme.breakpoints);
  var gridStyles = mediaQueries.reduce(function (acc, cur, idx) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, {
      paddingLeft: "".concat(getResponsiveNumber($gridMargins, idx)).concat($gridUnit),
      paddingRight: "".concat(getResponsiveNumber($gridMargins, idx)).concat($gridUnit),
      marginLeft: "-".concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit),
      marginRight: "-".concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit),
      alignItems: getResponsiveValue($align, idx)
    }));
  }, {
    paddingLeft: "".concat(getResponsiveNumber($gridMargins, 0)).concat($gridUnit),
    paddingRight: "".concat(getResponsiveNumber($gridMargins, 0)).concat($gridUnit),
    marginLeft: "-".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    marginRight: "-".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    alignItems: getResponsiveValue($align, 0)
  });
  return _objectSpread({
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: $behavior === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .BEHAVIOR.fixed */ .m6.fixed ? "".concat($gridMaxWidth + 2 * getResponsiveNumber($gridMargins, Infinity) - 1).concat($gridUnit) : null
  }, gridStyles);
});
StyledGrid.displayName = "StyledGrid";
var StyledCell = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref3) {
  var $theme = _ref3.$theme,
      _ref3$$align = _ref3.$align,
      $align = _ref3$$align === void 0 ? null : _ref3$$align,
      _ref3$$order = _ref3.$order,
      $order = _ref3$$order === void 0 ? null : _ref3$$order,
      _ref3$$gridColumns = _ref3.$gridColumns,
      $gridColumns = _ref3$$gridColumns === void 0 ? $theme.grid.columns : _ref3$$gridColumns,
      _ref3$$gridGaps = _ref3.$gridGaps,
      $gridGaps = _ref3$$gridGaps === void 0 ? $theme.grid.gaps : _ref3$$gridGaps,
      _ref3$$gridGutters = _ref3.$gridGutters,
      $gridGutters = _ref3$$gridGutters === void 0 ? $theme.grid.gutters : _ref3$$gridGutters,
      _ref3$$gridUnit = _ref3.$gridUnit,
      $gridUnit = _ref3$$gridUnit === void 0 ? $theme.grid.unit : _ref3$$gridUnit,
      _ref3$$skip = _ref3.$skip,
      $skip = _ref3$$skip === void 0 ? [0, 0, 0] : _ref3$$skip,
      _ref3$$span = _ref3.$span,
      $span = _ref3$$span === void 0 ? [1, 1, 1] : _ref3$$span;
  var mediaQueries = (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .getMediaQueries */ .W)($theme.breakpoints);
  var cellStyles = mediaQueries.reduce(function (acc, cur, idx) {
    if (getResponsiveNumber($span, idx) === 0) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        marginLeft: '0',
        marginRight: '0',
        display: 'none'
      }));
    }

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, {
      display: 'block',
      width: "calc(".concat(100 / getResponsiveNumber($gridColumns, idx) * Math.min(getResponsiveNumber($span, idx), getResponsiveNumber($gridColumns, idx)), "% - ").concat(getResponsiveNumber($gridGutters, idx)).concat($gridUnit, ")"),
      marginLeft: "calc(".concat(100 / getResponsiveNumber($gridColumns, idx) * Math.min(getResponsiveNumber($skip, idx), getResponsiveNumber($gridColumns, idx) - 1), "% + ").concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit, ")"),
      marginRight: "".concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit),
      marginBottom: "".concat(getResponsiveNumber($gridGaps, idx)).concat($gridUnit),
      alignSelf: getResponsiveValue($align, idx),
      order: getResponsiveNumber($order, idx)
    }));
  }, {
    width: '100%',
    marginLeft: "".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    marginRight: "".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    marginBottom: "".concat(getResponsiveNumber($gridGaps, 0)).concat($gridUnit),
    alignSelf: getResponsiveValue($align, 0),
    order: getResponsiveNumber($order, 0)
  });
  return _objectSpread({
    boxSizing: 'border-box'
  }, cellStyles);
});
StyledCell.displayName = "StyledCell";

function getResponsiveNumber(responsive, i) {
  var res = getResponsiveValue(responsive, i);
  return typeof res === 'number' ? res : 0;
}

function getResponsiveValue(responsive, i) {
  if (!responsive) {
    return null;
  }

  if (!Array.isArray(responsive)) {
    return responsive;
  }

  if (typeof responsive[i] === 'undefined') {
    return responsive[responsive.length - 1];
  }

  return responsive[i];
}

/***/ })

}]);